module.exports = __webpack_public_path__ + "static/media/compass-slash.9a49d202.svg";